import { useMemo } from 'react';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { getPaymentRecordTotal } from '../../hooks/useApplyPayments';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const alwaysUndefined = () => undefined;
const PaymentOption = ({
  option,
  currencyCode,
  balanceDue,
  onChange,
  selected
}) => {
  const disabled = getPaymentRecordTotal(option) > balanceDue;
  const emailProperty = useMemo(() => {
    return option.properties.find(property => property.name === 'hs_customer_email');
  }, [option]);
  const paymentId = useMemo(() => {
    return option.properties.find(property => property.name === 'hs_payment_id');
  }, [option]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(UITooltip, {
      use: disabled ? 'default' : 'longform',
      title: getPaymentRecordTotal(option) > balanceDue ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoicesHighlightCard.modals.applyExistingPayment.paymentExceedsBalance"
      }) : /*#__PURE__*/_jsxs("div", {
        className: "m-bottom-2",
        children: [/*#__PURE__*/_jsxs(UITruncateString, {
          tooltip: false,
          children: [/*#__PURE__*/_jsx("span", {
            className: "p-right-2",
            children: `${option.primaryDisplayProperty.definition.label}:`
          }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
            objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
            value: option.primaryDisplayProperty.value,
            property: option.primaryDisplayProperty.definition,
            getDraftValue: alwaysUndefined,
            getSavedValue: alwaysUndefined
          })]
        }, option.primaryDisplayProperty.name), option.secondaryDisplayProperties.map(property => {
          return /*#__PURE__*/_jsxs(UITruncateString, {
            tooltip: false,
            children: [/*#__PURE__*/_jsx("span", {
              className: "p-right-2",
              children: `${property.definition.label}:`
            }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
              objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
              value: property.value,
              property: property.definition,
              getDraftValue: alwaysUndefined,
              getSavedValue: alwaysUndefined
            })]
          }, property.name);
        })]
      }),
      children: /*#__PURE__*/_jsxs(UICheckbox, {
        className: "m-bottom-2",
        "data-test-id": "payment-option-checkbox",
        description: /*#__PURE__*/_jsxs(Small, {
          use: "help",
          children: [/*#__PURE__*/_jsx("span", {
            className: "p-right-2",
            children: `${paymentId.definition.label}:`
          }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
            objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
            value: paymentId.value,
            property: paymentId.definition,
            getDraftValue: alwaysUndefined,
            getSavedValue: alwaysUndefined
          })]
        }),
        disabled: disabled,
        onChange: event => onChange(event.target.checked, option),
        checked: selected,
        inline: true,
        children: [/*#__PURE__*/_jsx(FormattedCurrency, {
          currencyCode: currencyCode,
          value: getPaymentRecordTotal(option)
        }), ' (', /*#__PURE__*/_jsx(FormattedPropertyV2, {
          objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
          value: emailProperty.value,
          property: emailProperty.definition,
          getDraftValue: alwaysUndefined,
          getSavedValue: alwaysUndefined
        }), ')']
      }, option.id)
    })
  });
};
export default PaymentOption;